import React from "react";
import { NavLink } from "react-router-dom";

class AboutCompany5 extends React.Component {
  render() {
    return (
      <>
        <div className="section-full p-t80 bg-white">
          <div className="container">
            <div className="section-content ">
              <div className="m-service-containt text-black">
                <div className="row">
                  <div className="col-md-5 col-sm-12">
                    <div className="service-about-left">
                      <div className="mt-media">
                        <img
                          src={require("./../../images/extfile/cranes-are-lifting-materials-at-a-busy-constructio-2024-10-16-23-07-58-utc.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-7 col-sm-12">
                    <div className="service-about-right m-b30">
                      <h3 className="m-t0">
                        Integrated Building Management(BMS)
                      </h3>
                      <p>
                        At KUO ENTERPRISES LLP, our Integrated Building
                        Management Systems (BMS) offer seamless control and
                        management of essential building functions, creating
                        efficient, safe, and intelligent spaces. With our BMS
                        solutions, you can centrally monitor and manage key
                        systems, ensuring optimal performance, energy savings,
                        and enhanced security for commercial, industrial, and
                        residential buildings.
                      </p>
                      <h4>
                        Our Integrated Building Management Solutions Include:-
                      </h4>
                      <p>
                        <b>HVAC:</b>
                        Efficiently regulate heating, ventilation, and air
                        conditioning to maintain comfortable indoor environments
                        and reduce energy costs.
                      </p>
                      <p>
                        <b>Electricals/Lighting: </b>
                        Intelligent lighting and power control to optimize
                        energy use and enhance the building’s sustainability.
                      </p>
                      <p>
                        <b>Water Management: </b>
                        Monitor and control water resources to ensure
                        sustainable and cost-effective water usage across
                        facilities.
                      </p>
                      <p>
                        <b>Power Distribution:</b>
                        Manage power distribution for improved reliability and
                        reduced energy waste.
                      </p>
                      <p>
                        <b>Car Park Management:</b>
                        Streamlined management of parking spaces to maximize
                        utilization and improve user experience.
                      </p>
                      <p>
                        <b>Energy Data Evaluation:</b> Analyze energy
                        consumption data to identify areas for improvement and
                        implement energy-saving measures.
                      </p>
                      <p>
                        <b>Fire Detection and Alarm:</b>
                        Integrated fire safety systems for real-time monitoring,
                        quick response, and occupant safety.
                      </p>
                      <p>
                        <b>Elevator Management:</b>
                        Centralized control of elevator operations to ensure
                        efficiency and reduce downtime.
                      </p>
                      <p>
                        <b>CCTV Security:</b>
                        Comprehensive surveillance solutions for enhanced
                        security and peace of mind.
                      </p>
                      <p>
                        <b>Access Control:</b>
                        Secure and manage building access points to ensure only
                        authorized personnel enter restricted areas.
                      </p>
                      <p>
                        <b>Public Address System:</b>
                        Effective communication systems for building-wide
                        announcements and emergency notifications.
                      </p>
                      <p>
                        Our BMS solutions are designed to create cohesive,
                        interconnected buildings that are easier to manage, more
                        secure, and energy-efficient. By integrating all
                        building systems into one centralized platform, KUO
                        ENTERPRISES LLP helps you create smarter, more
                        sustainable environments that improve operational
                        efficiency and contribute to a safer, more comfortable
                        experience for all occupants.
                      </p>

                      <div className="call-for-quote-outer">
                        <div className="call-quote">
                          <span>Call For a Quote:</span>
                          <h4> +91 8921197287, 9437630763</h4>
                        </div>
                        <div className="call-estimate bg-dark">
                          <NavLink
                            to={"#"}
                            className="site-button-secondry btn-effect"
                          >
                            Online Estimate Form
                          </NavLink>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default AboutCompany5;
